import { inject, injectable } from "inversify";
import { CachingPolicyException } from "../../domain/exceptions/caching-policy-exception";
import { ITracker } from "../../domain/interfaces/tracker.interface";
import { DI } from "../di";
import { Request } from "../request";
import { Response } from "../response";

@injectable()
export class CachingPolicy {

	@inject(DI.TRACKER) private tracker: ITracker;

	public validate(request: Request, response: Response): void {

		if (!response.cachingSpecification || !response.cachingSpecification.ttl) {

			this.failed(request.url, "Invalid caching specification");
		}

		if (response.cachingSpecification!.ttl! < 31536000) {

			this.failed(request.url, "Cache TTL too low");
		}
	}

	private failed(url: string, type: string): void {

		this.trackInvalidCachingSpecification(url);
		this.throwException(type);
	}

	private throwException(type: string): any {

		throw new CachingPolicyException(type);
	}

	private trackInvalidCachingSpecification(url: string) {

		this.tracker.trackEvent({
			url,
			category: "Microservice",
			action: "RequestFailed",
			label: "InvalidCachingSpecification"
		});
	}
}
